import React from "react";
import { apiEndpoint } from "helpers/url_helper";

import { render } from "react-dom";
// Import Highcharts
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import exportingModule from "highcharts/modules/exporting"
exportingModule(Highcharts)
require("highcharts/modules/export-data.js")(Highcharts);
import highcharts3d from "highcharts/highcharts-3d";
highcharts3d(Highcharts);

 var exampleColors = ["rgb(15,72,127)", "rgb(52,109,164)", "rgb(88,145,200)", "rgb(124,181,236)", "rgb(160,217,255)", "rgb(196,253,255)", "rgb(233,255,255)", "rgb(255,255,255)", "rgb(255,255,255)", "rgb(255,255,255)"]
  
class DiskChartBK extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
          speedData: [],
         //datetime:[]
        }
   
        this.afterChartCreated = this.afterChartCreated.bind(this);
    this.state = {
      chartOptions: {
        chart: {
          type: 'pie',
          backgroundColor: 'rgba(0,0,0,0)',
         margin: [0,0,0,15],
         spacingTop: 0,
         spacingBottom: 0,
         spacingLeft: 0,
         spacingRight: 0,
         options3d: {
             enabled: true,
             alpha: 75,
             beta: 0
         }
        
        },
        title: {
          text: ""
        },
        credits: {
            enabled: false
        },
        accessibility: {
          point: {
              valueSuffix: '%'
          }
      },
      tooltip: {
          pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
      },

         
        plotOptions: {
          pie: {
              allowPointSelect: false,
              slicedOffset: 40,
        shadow:true,
              startAngle:180,
              cursor: 'pointer',
              depth: 55,
              size: '120%',
              colors:exampleColors,
              borderColor: '#000000',
              color: '#000000',
              innerSize:155,
              depth: 45,
              dataLabels: {
                  enabled: true,
                  color: 'black',
                  fontSize:"x-large"
                },
             },
      series: {
              //required to drilldown
              allowPointSelect: true,
               dataLabels: {
                  enabled: false,
                  format: '{point.name}'
              },
              point: {
                  events: {
                     
                      select: function(selected) {
                          var points = this.series.points;
                          console.log("selected",selected.target);
                          points.forEach(p =>{
                          p.category = p.color
                          p.id !== selected.target.id ? p.color = Color(p.color).lighten(.3).alpha(.3).toString():{};
                          })
                      }, unselect: function(selected) {
                          console.log("unselect");
                          var points = this.series.points;
                        
                          points.forEach(p =>{
                          p.color = p.category;
                          })
                      }
                  }
              },
          }
    },
      
        series: [
          {      name: "Speed Distribution",
          colorByPoint: true,
          data:this.state.speedData
          },
        ],
        rangeSelector: {
          selected: 6
      },
       // exporting: {
        // showTable: false
        // },
        exporting: {
          buttons: {
            contextButton: {
              menuItems: [
                "viewFullscreen",
                       "printChart",
                          "separator",
                          "downloadPNG",
                          "downloadJPEG",
                          "downloadPDF",
                          "downloadSVG",
                          "separator",
                          "downloadCSV",
                          "downloadXLS",
                          //"viewData",
                         ]
            }
          }
          ,
          filename:"Speed Distribution_"+new Date().toLocaleDateString()
        },
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 2000
              }
            }
          ]
        }
      }
    };
  }

  afterChartCreated(chart) {
    if (!chart.options.chart.forExport) {
      this.internalChart = chart;
      this.forceUpdate();
    }
  }

 async componentDidUpdate(prevProps) {
   if(prevProps.props!=this.props.props){
    // can't change
    const response = await fetch(apiEndpoint+"/GetSpeedDistributionData", {
      
    method: 'POST',
    headers: {
        'Content-Type': 'application/json', 
    },
    body:this.props.props
  });
    console.log(response);
   if(response.body!=null && response !=undefined)
   {
  const data = await response.json();
  var objToArr=JSON.parse( data.speed);
  const newArrayOfObj = (objToArr).map(({
    "Speed": name,
    "Count":y,
    ...rest
  }) => ({
    name,y,
    ...rest
  }));
  var convertedArr = newArrayOfObj.map((o) => ({ name: o.name+" to " + parseInt(parseInt(o.name)+10), y:o.y}))
  this.setState({speedData:convertedArr})
  if(this.internalChart.series!=undefined){
  this.internalChart.series[0].setData(convertedArr);
  }
   }
   }
    //
  }

  async UNSAFE_componentWillReceiveProps (props) {
    console.log(props.props)
    if(props.props!=undefined){
      // can't change
      const response = await fetch(apiEndpoint+"/GetSpeedDistributionData", {
      
      method: 'POST',
      headers: {
          'Content-Type': 'application/json', 
      },
      body:props.props
    });
      console.log(response);
     if(response.body!=null && response !=undefined)
     {
    const data = await response.json();
    var objToArr=JSON.parse( data.speed);
    const newArrayOfObj = (objToArr).map(({
      "Speed": name,
      "Count":y,
      ...rest
    }) => ({
      name,y,
      ...rest
    }));
  
    var convertedArr = newArrayOfObj.map((o) => ({ name: o.name+" to " + parseInt(parseInt(o.name)+10), y:o.y}))
    this.setState({speedData:convertedArr})
    if(this.internalChart.series!=undefined){
    this.internalChart.series[0].setData(convertedArr);
    }
     }
    }
    }
   
  render() {
    console.log(this.state.speedData)
    return (
      <HighchartsReact
        style={{ height: "100%" }}
        highcharts={Highcharts}
        options={this.state.chartOptions}
        callback={this.afterChartCreated}
       updateArgs={[true]}
      />
    );
  }
}

export default DiskChartBK;